const getDetailsData = ({ report: { summary } }) => ({
  detailsData: summary.detailsData,
  requestStatus: summary.requestStatus,
});

export default getDetailsData;
